<template>
  <div class="navbar-warpper">
    <el-menu :router="true" :default-active="`${sysPath}/` + activeIndex" class="el-menu-demo" mode="horizontal">
      <navbarItem v-for="router in routes" :key="router.path" :item="router" :base-path="router.path"></navbarItem>
    </el-menu>
  </div>
</template>

<script>
import navbarItem from "./navbarItem.vue";
export default {
  name: "NavBar",
  data() {
    return {};
  },
  mounted() {},
  methods: {},
  computed: {
    routes() {
      return this.$router.options.routes.find((e) => e.name === "sys").children;
    },
    sysPath() {
      const sysRoute = this.$router.options.routes.find((e) => e.name === "sys");
      return sysRoute ? sysRoute.path : "/sys";
    },
    activeIndex() {
      return this.$route.path.split("/")[2];
    },
  },
  components: {
    navbarItem,
  },
};
</script>

<style lang="scss" scoped>
.navbar-warpper {
  height: vw(80);
  .el-menu-item {
    height: vw(80);
    padding-left: vw(20);
    padding-right: vw(20);
    background-color: #2851cd;
    line-height: vw(80);
    color: #fff;
    font-weight: bold;
    font-size: vw(18);
  }
  .el-menu--horizontal > .el-menu-item:not(.is-disabled):focus,
  .el-menu--horizontal > .el-menu-item.is-active {
    background-color: #2851cd;
    color: orange;
  }
  .el-menu-item:not(.is-disabled):hover {
    background-color: #4b74ef;
    color: orange;
  }
  .el-menu--horizontal > .el-menu-item.is-active {
    border-bottom: vw(3) solid orange;
  }
  .el-menu::after {
    display: none;
  }
}
</style>
